export const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
